import { defineMessages } from "react-intl";
import { NoteType } from "../../contract/pam.js";
const localizedNoteType = defineMessages({
  [NoteType.Global]: {
    id: "localizedNoteTypeGlobal",
    defaultMessage: "Player Record"
  },
  [NoteType.Request]: {
    id: "localizedNoteTypeRequest",
    defaultMessage: "Current Request ID"
  }
});
export {
  localizedNoteType
};
//# sourceMappingURL=notetype.js.map
